export default __webpack_public_path__ + "static/media/xx99-mark-ii-on-table.96c91871.png";